import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function GelatoSparklingPage() {
  return <div className="min-h-screen bg-white" data-id="element-1022">
      {/* Header */}
      <Header variant="solid" data-id="element-1023" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1024">
        <div className="max-w-4xl mx-auto" data-id="element-1025">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1026">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1027">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1028">/</span>
            <span className="text-neutral-900" data-id="element-1029">
              When Gelato Met Sparkling Wines!
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1030">
            When Gelato Met Sparkling Wines!
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1031">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Glass-1-Right-cellar-door.jpg" alt="Gelato and Sparkling Wines" className="w-full h-full object-cover" data-id="element-1032" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-1033">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1034">
              When visiting the Hunter Valley there are a plethora of wine
              tastings on offer, made special by each winery. Here at Peterson
              House, we have a few different options to enjoy tasting our
              sparkling wines. Have you heard of our popular Gelato and
              Sparkling Wine tasting experience?
            </p>

            {/* Unique Approach */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1035">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1036">
                We wanted a different approach to wine tasting, to enhance the
                bubbly experience and create an immersive way for people to
                enjoy our sparkling wines. We took a chance and it worked; we
                have now seen new customers visit our cellar door to enjoy this
                unique experience.
              </p>
            </div>

            {/* The Experience */}
            <div className="mb-8" data-id="element-1037">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1038">
                The Experience
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1039">
                Sit down with your guests and enjoy four scoops of locally
                sourced gelato flavours (The Smelly Cheese Shop), matched with
                our Peterson House Bubbles.
              </p>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1040">
                To make this a fun and memorable experience, the gelato flavours
                are a mystery! Our guests enjoy trying to predict the flavours
                making this an immersive and sensory experience.
              </p>
            </div>

            {/* Closing */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1041">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1042">
                We love trying new and exciting things and of course we
                absolutely love sparkling wines! So why not pop in and indulge
                in a delicious gelato and sparkling wine tasting right here in
                the heart of the Hunter Valley at Peterson House.
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-1043">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1044">
                Ready to Try This Unique Experience?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-1045">
                Visit our cellar door to enjoy the Gelato and Sparkling Wine
                tasting experience. A sensory adventure like no other in the
                Hunter Valley!
              </p>
              <a href="/cellar-door" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1046">
                Visit Cellar Door
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1047" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1048">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1049">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1050" />
    </div>;
}